import { useEffect, useState } from 'react';
import { OTP_ACTIONS } from '../../utils/constants';
import Header from '../../lib/AppBar';
import {
    QuestionnaireFields,
    secretQuestionsPayload,
    selectedQuestionValidation,
} from '../auth/SignUpQuestionnaire';
import { Button, Switch } from '@material-ui/core';
import { connect } from 'react-redux';
import { saveSecretQuestions } from '../../redux-store/actions/login';
import {
    getSecurityQuestions,
    getSecretQuestionsAnswers,
    updateSecurityQuestionsForUser,
    sendPhoneOTP,
} from '../../redux-store/actions/nct';
import en from '../../lang/en-us';
import { RootStateType } from '../../redux-store/reducers';
import { NoteModals } from '../../lib/NoteModals';
import { LIST_PROTFOLIO_PAYLOAD } from '../../redux-store/types/portfolio';

const { myProfile, updateSecurityQuestion, secretQuestionnaire, dashboard } = en;

type GET_SECURITY_QUESTION_ANSWER = {
    createdDateTime: number;
    questionTypeId: number;
    secretAnswer: string;
    secretQuestion: string;
    updatedDateTime: number;
};

const initialValues = new Array(5).fill({
    questionTypeId: '',
    secretAnswer: '',
});

function UpdateSecurityQuestion(props: any) {
    const [state, setState] = useState<any>(initialValues);
    const [questionsData, setData] = useState<any>([]);
    const [selectedIds, setSelectedIds] = useState<selectedQuestionValidation[]>([]);
    const [submitting, setSubmitting] = useState(false);
    const [errors, setErrors] = useState<any>(
        new Array(5).fill({
            question: '',
        }),
    );
    const [answerErrors, setAnswerErrors] = useState<any>([]);
    const [showDialog, setDialog] = useState<boolean>(false);

    useEffect(() => {
        async function callApi() {
            try {
                const { pan = '', pekrn = '', mobile = '', reqId = '' } = props;
                const payload: LIST_PROTFOLIO_PAYLOAD = {
                    reqId,
                    pan,
                    pekrn,
                    mobile,
                };
                const { body: questions } = await props.getSecurityQuestions(payload);
                setData(questions.map((question: any) => ({ ...question, show: true })));
                let res = await props.getSecretQuestionsAnswers(payload);
                const { body: answers } = res;
                setState(
                    answers.map((_ele: GET_SECURITY_QUESTION_ANSWER) => ({
                        questionTypeId: _ele.questionTypeId,
                        secretAnswer: _ele.secretAnswer,
                    })),
                );
                setSelectedIds(
                    answers.map((_ele: GET_SECURITY_QUESTION_ANSWER, index: number) => ({
                        question_id: _ele.questionTypeId,
                        index,
                    })),
                );
            } catch (e: any) {
                alert(e.message);
            }
        }
        callApi();
    }, []);

    useEffect(() => {
        // Getting the ids of the currently selected questions
        let selectedQuestionIds: any = [];
        selectedIds.forEach((_ele: any) => {
            selectedQuestionIds.push(_ele.question_id);
        });

        let qData = questionsData.map((_ele: any) => {
            //set show to false if current question id is selected else true.
            _ele.show = selectedQuestionIds.includes(_ele.questionTypeId) ? false : true;
            return _ele;
        });

        setData(qData);
    }, [selectedIds]);

    const handleQuestionSelection = (id: number, index: number) => {
        const findIndex = selectedIds.findIndex(
            (_ele: selectedQuestionValidation) => _ele.index === index,
        );
        findIndex === -1
            ? setSelectedIds([...selectedIds, { question_id: id, index }])
            : setSelectedIds(
                selectedIds.map((_ele: selectedQuestionValidation) => {
                    if (index === _ele.index) {
                        return { question_id: id, index };
                    }
                    return _ele;
                }),
            );
        const updatedIds = state.map((_ele: secretQuestionsPayload, ind: number) => {
            if (index === ind) {
                return {
                    ..._ele,
                    questionTypeId: id,
                };
            }
            return _ele;
        });
        setState(updatedIds);
    };

    const handleAnswerChange = (value: string, index: number) => {
        const updatedAnswers = state.map((_ele: secretQuestionsPayload, ind: number) => {
            if (index === ind) {
                return {
                    ..._ele,
                    secretAnswer: value,
                };
            }
            return _ele;
        });
        setState(updatedAnswers);
    };

    const validateForm = () => {
        let errors: any = [];
        let answerErrors: any = [];
        const checkForQuestionErrors = state
            .map((_ele: secretQuestionsPayload, index: number) => {
                if (!_ele.questionTypeId) {
                    answerErrors[index] = { question: 'Please select security question' };
                }
            })
            .filter((_ele: any) => _ele);
        const checkForErrors = state
            .map((_ele: secretQuestionsPayload, index: number) => {
                if (!_ele.secretAnswer) {
                    errors[index] = { answer: 'Please enter your answer' };
                }
                if (_ele.secretAnswer.trim().length > 100) {
                    errors[index] = { answer: 'Answer must be less than 100 characters' };
                }
            })
            .filter((_ele: any) => _ele);
        if (checkForErrors.length === 0 || checkForQuestionErrors.length === 0) {
            return true;
        } else {
            if (checkForErrors.length) {
                setAnswerErrors(errors);
            }
            if (checkForQuestionErrors.length) {
                setErrors(answerErrors);
            }
            return false;
        }
    };

    const handleSubmit = async () => {
        if (validateForm()) {
            try {
                setSubmitting(true);
                const { pan, pekrn, mobile, userRegisteredWith, email = '' } = props;
                let res = await props.sendPhoneOTP({
                    mobile,
                    pan,
                    pekrn,
                    action: OTP_ACTIONS.SECURITY_ANSWER,
                });
                props.history.push('update-security-questions-otp', {
                    state,
                    mobile: userRegisteredWith === 'EMAIL' ? email : mobile,
                    ...(res || {}).body,
                });
                setDialog(true);
            } catch (e: any) {
                alert(e.message);
            } finally {
                setSubmitting(false);
            }
        }
    };

    return (
        <div className="curved-bg profile-page security-questions">
            <h2 className="heading">
                <a
                    role="button"
                    tabIndex={0}
                    aria-label="Go back to profile"
                    onClick={() => props.history.push('/portal/profile')}
                    onKeyDown={(e: React.KeyboardEvent) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault();
                            props.history.push('/portal/profile');
                        }
                    }}
                >
                    <img src="/images/left-arrow-black.svg" alt="" aria-hidden="true" />
                </a>
                {updateSecurityQuestion.heading}
            </h2>

            <div className="curved-bg-content">
                <div className="login-content signup-questionnaire">
                    <div className="signup-questionnaire-inner">
                        <div className="signup-questionnaire-form">
                            {state.map((_ele: secretQuestionsPayload, index: number) => (
                                <QuestionnaireFields
                                    questions={questionsData}
                                    value={state[index].questionTypeId || ''}
                                    answer={state[index].secretAnswer || ''}
                                    _handleSelection={(id: number) => {
                                        setErrors(
                                            errors.map((_ele: string, ind: number) => {
                                                if (index === ind) {
                                                    return { question: '' };
                                                }
                                                return _ele;
                                            }),
                                        );
                                        handleQuestionSelection(id, index);
                                    }}
                                    _handleTextChange={(value: string) => {
                                        setAnswerErrors(
                                            answerErrors.map((_ele: string, ind: number) => {
                                                if (index === ind) {
                                                    return { answer: '' };
                                                }
                                                return _ele;
                                            }),
                                        );
                                        handleAnswerChange(value, index);
                                    }}
                                    index={index + 1}
                                    error={errors[index]?.question || ''}
                                    answerError={answerErrors[index]?.answer || ''}
                                    variant={'outlined'}
                                    isUpdate={true}
                                />
                            ))}
                            {submitting ? (
                                <Button fullWidth className="customBtn">
                                    Submitting
                                    <span className="sending-dots">
                                        <i></i>
                                        <i></i>
                                        <i></i>
                                    </span>
                                </Button>
                            ) : (
                                <Button
                                    className="customBtn"
                                    variant="contained"
                                    disabled={
                                        errors.some((_el: any) => !!_el.question) ||
                                        answerErrors.some((_el: any) => !!_el.answer) ||
                                        !state.every(
                                            (_ele: secretQuestionsPayload) =>
                                                _ele.questionTypeId && _ele.secretAnswer,
                                        )
                                    }
                                    onClick={handleSubmit}
                                >
                                    {secretQuestionnaire.submit}
                                </Button>
                            )}
                            <NoteModals
                                showModal={showDialog}
                                heading={dashboard.Success.success}
                                info={dashboard.Success.securityQuestions}
                                proceedBtn={'Okay'}
                                onProceed={() => props.history.push('/portal/profile')}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default connect(({ authReducer }: RootStateType) => ({ ...authReducer }), {
    saveSecretQuestions,
    getSecurityQuestions,
    getSecretQuestionsAnswers,
    updateSecurityQuestionsForUser,
    sendPhoneOTP,
})(UpdateSecurityQuestion);
